'use client';

import { useCallback } from 'react';

import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';
import { prefersReducedMotion } from '@/lib/utils/motion';

interface SkipToContentProps {
  targetId?: string;
  className?: string;
}

export function SkipToContent({ targetId = 'main-content', className }: SkipToContentProps) {
  const t = useTranslations();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      const target = document.getElementById(targetId);
      if (target) {
        target.focus();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    },
    [targetId],
  );

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className={cn(
        'absolute start-0 top-0 z-[9999] -translate-y-full bg-primary px-4 py-2 text-primary-foreground transition-transform',
        'focus:translate-y-0 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-none',
        className,
      )}
    >
      {t('accessibility.skipToContent')}
    </a>
  );
}
